/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/* Storage */
import { selectRequestById, RequestRecord } from '../storage/requests';

type RequestSelector = (state: unknown) => ReturnType<typeof RequestRecord>;

export default function useRequest(requestId: string) {
  const requestSelector = useMemo((): RequestSelector => selectRequestById(requestId), [requestId]);
  return useSelector(requestSelector);
}
